import {FETCH_ITEMS_FOR_STEP, FETCH_ITEMS_FOR_STEP_START, FETCH_ITEMS_FOR_STEP_END} from "./actions";
import {StepOffers} from "./types";

const initialState: StepOffers = null;

export function stepOffersReducer(
    state = initialState,
    action: any
): StepOffers {
    switch (action.type) {
        case FETCH_ITEMS_FOR_STEP_START: {
            return {...state, isLoading: true};
        }
        case FETCH_ITEMS_FOR_STEP: {
            const data = action.payload;
            return {...state, tabs: data.tabs};
        }
        case FETCH_ITEMS_FOR_STEP_END: {
            return {...state, isLoading: false};
        }
        default:
            return state
    }
}
